import type { MediaComment, MediaCommentRequest } from '@cobliteam/common-types';
import camelcaseKeys from 'camelcase-keys';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class MediaCommentRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public createComment = async ({ mediaId, content }: MediaCommentRequest): Promise<MediaComment> => {
    const requestData: IRequest = {
      endpoint: `/cameras/media/${mediaId}/comment`,
      method: HttpMethod.POST,
      body: JSON.stringify({ content: content }),
    };

    const { data } = await this.requester.request(requestData);

    return camelcaseKeys(data);
  };

  public updateComment = async ({ mediaId, content, commentId }: MediaCommentRequest): Promise<MediaComment> => {
    const requestData: IRequest = {
      endpoint: `/cameras/media/${mediaId}/comment/${commentId}`,
      method: HttpMethod.PATCH,
      body: JSON.stringify({ content: content }),
    };

    const { data } = await this.requester.request(requestData);

    return camelcaseKeys(data);
  };

  public deleteComment = async ({ mediaId, commentId }: MediaCommentRequest) => {
    const requestData: IRequest = {
      endpoint: `/cameras/media/${mediaId}/comment/${commentId}`,
      method: HttpMethod.DELETE,
    };

    await this.requester.request(requestData);
  };
}

export default MediaCommentRequester;
